import React, { useState, useEffect, useContext } from "react";
import "./MyLucky.scss";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import { ThemeContext } from "../../store/ThemeProvider";
import ListWrapper from "../Common/ListWrapper";
import { ICommonMyList } from "./AllForMe";
import { IListResult } from "../../global";
import GorgeousHeader from "../Followee/GorgeousHeader";
import intl from "react-intl-universal";
import { style } from "../../utils/image";
import { alpha } from '../../utils/color';
import { getPendantColor } from "../../utils/color";
import moment from "moment";
import MobileModal, {
  NAME_MOBILE_TEMPLATE,
} from "../ComponentLucky/MobileModal";
import chroma from "chroma-js";

export interface IMyLucky extends ICommonMyList {
  rootStore?: RootStore;
}

const Index = (props: IMyLucky) => {
  const { componentColor, h1Color, mainColor, h2Color, backgroundColor } =
    useContext(ThemeContext);
  const { list, rootStore } = props;
  const { luckyStore, uiStore } = rootStore!;

  const [bgColor, foreColor] = getPendantColor(mainColor);
  let { data, total } = list || ({} as IListResult);

  const [inited, setInited] = useState(false);
  useEffect(()=>{
    setInited(true);
  }, []);

  const [editItem, setEditItem] = useState(null as any);
  const needSubmit = (item: any) => {
    setEditItem(item);
  };

  const onFormSubmit = (data: any) => {
    // if(editItem && editItem.id) {
    let formValue = {
      address: "",
    } as {
      [key: string]: string;
    };

    if (data && Object.keys(data).length) {
      Object.keys(data).forEach((key: string) => {
        let row = data[key];
        if (row && row.type == "form_input") {
          formValue.name = row.value;
        }
        if (row && row.type == "form_phone" && row.value && row.value.phone) {
          formValue.mobile = row.value.phone;
        }
      });
    }

    return luckyStore.doRecord(editItem.id || 0, formValue).then((res: any) => {
      if (res) {
        let { code } = res;
        if (code == 200) {
          uiStore.showToast({
            content: "领取成功，请留意客服电话",
          });
          setEditItem(null);
          if (props.refresh) {
            props.refresh();
          }
        }
        if (code == 200401) {
          uiStore.showToast({
            content: "已领取过",
          });
        }
        if (code == 200402) {
          uiStore.showToast({
            content: "系统错误，稍候再试",
          });
        }
      }

      return res;
    });
    // }
  };

  return (
    <div className="my-lucky">
      {!!inited ? <>
        <ListWrapper
          onRefresh={props.refresh}
          onLoadMore={props.loadMore}
          scrollerChildrenSelector={".my-lucky"}
          eventName={"lucky"}
        >
          <>
            {(data || []).map((it: any) => {
              const { id, luckdetail, goodsdetail, status, created_at } = it;
              return (
                <div className="lucky-item" key={id}>
                  <div className="thumb">
                    <img src={style(goodsdetail.thumb, "avatar_150", {webp:true})} />
                  </div>
                  <div className="info">
                    <div className="times">
                      <div className="name" style={{ color: h1Color }}>
                        {goodsdetail.desc}
                      </div>
                      <div className="time" style={{ color: h2Color }}>
                        {intl.get("Got Time")}:
                        {moment(created_at).format("YYYY-MM-DD HH:mm:ss")}
                      </div>
                      {luckdetail && !luckdetail.deleted_at ? (
                        <div className="time" style={{ color: h2Color }}>
                          {intl.get("Expired Time")}:
                          {luckdetail
                            ? moment(luckdetail.end_at)
                                .add(1, "d")
                                .format("YYYY-MM-DD HH:mm:ss")
                            : intl.get("Expired")}
                        </div>
                      ) : null}
                    </div>
                    <div className="status">
                      {status == 0 && luckdetail ? (
                        moment(luckdetail.end_at)
                          .add(1, "d")
                          .isBefore(moment()) ||
                        it.deleted_at ||
                        luckdetail.deleted_at ? (
                          // 失效状态
                          <a
                            className="dismiss"
                            style={{
                              color: h2Color,
                              background: chroma(h2Color).alpha(0.3).css(),
                            }}
                          >
                            {intl.get("Expired")}
                          </a>
                        ) : (
                          // 未提交信息状态
                          <a
                            className="wait"
                            onClick={() => {
                              needSubmit(it);
                            }}
                            style={{ color: foreColor, background: mainColor }}
                          >
                            {intl.get("LuckySubmit")}
                          </a>
                        )
                      ) : null}
                      {status == 1 ? (
                        // 已领取状态
                        <a className="got" style={{ color: mainColor }}>
                          {intl.get("Got")}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        </ListWrapper>
      </> : null}

      {!!editItem ? (
        <MobileModal
          onClose={() => setEditItem(null)}
          onSubmit={onFormSubmit}
          visible={!!editItem}
          formTemplate={NAME_MOBILE_TEMPLATE(editItem.luckdetail)}
        />
      ) : null}
    </div>
  );
};

export default inject("rootStore")(observer(Index));
